<h2 *ngIf="!isLoading && parameterConfigs.parameters_from_definition">Parameters</h2>

<!-- Loading state -->
<div *ngIf="isLoading" class="parameters-loading">
    <div class="loading-spinner"></div>
    <span class="loading-text">Loading parameters...</span>
</div>

<!-- Parameters content -->
<div *ngIf="!isLoading" [formGroup]="parametersForm" class="parameter-options">
    <div *ngFor="let column of parameterConfigs.parameters_from_definition" class="parameter-container">
        <div class="parameter-column">
            <!-- DateTimeParameterDeclaration -->
            <div *ngIf="column.DateTimeParameterDeclaration" [class.parameter-error]="hasError(column.DateTimeParameterDeclaration.Name)">
                <div>{{column.label}} <span *ngIf="isParameterRequired(column.DateTimeParameterDeclaration.Name)" class="required">*</span></div>
                <input type="date" class="parameter-column" (change)="updateParameters()"
                    [formControlName]="column.DateTimeParameterDeclaration.Name" />
                <div *ngIf="hasError(column.DateTimeParameterDeclaration.Name)" class="inline-error-message">
                    {{getErrorMessage(column.DateTimeParameterDeclaration.Name)}}
                </div>
            </div>
            
            <!-- StringParameterDeclaration SINGLE_VALUED -->
            <div
                *ngIf="column.StringParameterDeclaration && column.StringParameterDeclaration.ParameterValueType === 'SINGLE_VALUED'"
                [class.parameter-error]="hasError(column.StringParameterDeclaration.Name)">
                <div>{{column.label}} <span *ngIf="isParameterRequired(column.StringParameterDeclaration.Name)" class="required">*</span></div>
                <input *ngIf="!column.options"
                    [type]="column.StringParameterDeclaration.Name === 'pStartDate' ? 'date' : 'text'"
                    class="parameter-column" (change)="updateParameters()"
                    [formControlName]="column.StringParameterDeclaration.Name" />
                <select *ngIf="column.options" [formControlName]="column.StringParameterDeclaration.Name"
                    (change)="updateParameters()" [id]="column.StringParameterDeclaration.Name"
                    class="parameter-select-menu">
                    <option *ngFor="let option of column.options" [value]="option?.name || option">
                        {{ option?.name || option }}
                    </option>
                </select>
                <div *ngIf="hasError(column.StringParameterDeclaration.Name)" class="inline-error-message">
                    {{getErrorMessage(column.StringParameterDeclaration.Name)}}
                </div>
            </div>

            <!-- StringParameterDeclaration MULTI_VALUED -->
            <div
                *ngIf="column.StringParameterDeclaration && column.StringParameterDeclaration.ParameterValueType === 'MULTI_VALUED' && column.StringParameterDeclaration.Name"
                [class.parameter-error]="hasError(column.StringParameterDeclaration.Name)">
                <div class="row-container">
                    <span>{{column.label}} <span *ngIf="isParameterRequired(column.StringParameterDeclaration.Name)" class="required">*</span></span>
                    <span (click)="toggleSelectAll(column.StringParameterDeclaration.Name)">
                        {{isAllSelected(column.StringParameterDeclaration.Name) ? 'Deselect All' : 'Select All'}}
                    </span>
                </div>
                <select [formControlName]="column.StringParameterDeclaration.Name" (change)="updateParameters()"
                    [id]="column.StringParameterDeclaration.Name" class="parameter-select-menu" multiple>
                    <option *ngFor="let option of column.options" [value]="option?.name || option">
                        {{ option?.name || option }}
                    </option>
                </select>
                <div *ngIf="hasError(column.StringParameterDeclaration.Name)" class="inline-error-message">
                    {{getErrorMessage(column.StringParameterDeclaration.Name)}}
                </div>
            </div>

            <!-- IntegerParameterDeclaration SINGLE_VALUED -->
            <div
                *ngIf="column.IntegerParameterDeclaration && column.IntegerParameterDeclaration.ParameterValueType === 'SINGLE_VALUED'"
                [class.parameter-error]="hasError(column.IntegerParameterDeclaration.Name)">
                <div>{{column.label}} <span *ngIf="isParameterRequired(column.IntegerParameterDeclaration.Name)" class="required">*</span></div>
                <input type="number" class="parameter-column" (change)="updateParameters()"
                    [formControlName]="column.IntegerParameterDeclaration.Name" />
                <div *ngIf="hasError(column.IntegerParameterDeclaration.Name)" class="inline-error-message">
                    {{getErrorMessage(column.IntegerParameterDeclaration.Name)}}
                </div>
            </div>

            <!-- IntegerParameterDeclaration MULTI_VALUED -->
            <div
                *ngIf="column.IntegerParameterDeclaration  && column.IntegerParameterDeclaration.ParameterValueType === 'MULTI_VALUED'"
                [class.parameter-error]="hasError(column.IntegerParameterDeclaration.Name)">
                <div class="row-container">
                    <span>{{column.label}} <span *ngIf="isParameterRequired(column.IntegerParameterDeclaration.Name)" class="required">*</span></span>
                    <span (click)="toggleSelectAll(column.IntegerParameterDeclaration.Name)">
                        {{isAllSelected(column.IntegerParameterDeclaration.Name) ? 'Deselect All' : 'Select All'}}
                    </span>
                </div>
                <select [formControlName]="column.IntegerParameterDeclaration.Name" (change)="updateParameters()"
                    [id]="column.IntegerParameterDeclaration.Name" class="parameter-column" multiple>
                    <option *ngFor="let option of column.IntegerParameterDeclaration.DefaultValues.StaticValues"
                        [value]="option">
                        {{ option }}
                    </option>
                </select>
                <div *ngIf="hasError(column.IntegerParameterDeclaration.Name)" class="inline-error-message">
                    {{getErrorMessage(column.IntegerParameterDeclaration.Name)}}
                </div>
            </div>
        </div>
    </div>
</div>

<!-- No parameters message -->
<div *ngIf="!isLoading && (!parameterConfigs.parameters_from_definition || parameterConfigs.parameters_from_definition.length === 0)">
    <p>No parameters available for this dashboard.</p>
</div>